import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
} from "@material-ui/core";
import { addMascaraReal, formatarDouble } from "../../helper/utils";
import "../../App/style.css";
import "./style.css";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import { setPaymentCreditCardObject } from "../../actions";
import { bindActionCreators } from "redux";

const PaymentSimulation = ({ ...props }) => {
  const dispatch = useDispatch();
  const [parcela, setParcela] = useState("");
  const [quantidadeDeParcelas, setQuantidadeDeParcelas] = useState("");

  const [ValorDaParcela, setValorDaParcela] = useState("");
  const [valorTotal, setValorTotal] = useState("");
  const [taxaMensal, setTaxaMensal] = useState(null);
  const [cet, setCet] = useState(null);
 
  const handleChange = (event) => {
    setParcela(event.target.value);
  };

  React.useEffect(() => {
    setQuantidadeDeParcelas(parcela.QuantidadeParcelas);
    if (parcela.Valor !== undefined) {
      setValorDaParcela(addMascaraReal(parcela.Valor));
    }
    if (parcela.ValorTotal !== undefined) {
      setValorTotal(addMascaraReal(parcela.ValorTotal));
    }
    if (parcela.Cet !== undefined) {
      setCet(parcela.Cet !== null ? formatarDouble(parcela.Cet) : parcela.Cet);
    }
    if (parcela.TaxaMensal !== undefined) {
      setTaxaMensal(
        parcela.TaxaMensal !== null
          ? formatarDouble(parcela.TaxaMensal)
          : parcela.TaxaMensal
      );
    }
    dispatch(
      setPaymentCreditCardObject({
        NumeroDam: props.simulationData.NumeroDam,
        SiglaAdquirente: props.simulationData.SiglaAdquirente,
        TokenSimulacao: props.simulationData.TokenSimulacao,
        QuantidadeParcelas: parcela.QuantidadeParcelas,
      })
    );
  }, [
    dispatch,
    parcela,
    props.simulationData.NumeroDam,
    props.simulationData.Parcelas,
    props.simulationData.SiglaAdquirente,
    props.simulationData.TokenSimulacao,
  ]);
  
  return (
    <Dialog
      open={props.open}
      onClose={() => props.controllerPayment(false)}
      width="lg"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Pagamento com cartão { props.acquirerSelected.length > 0 && "na " + props.acquirerSelected[0].NomeFantasia }</DialogTitle>
      <DialogContent id="alert-dialog-description">
        <Box padding={2}>
          <div>
            <p>
              Selecione a forma de pagamento:
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={parcela}
                label="Parcelas"
                onChange={handleChange}
                style={{ width: "180px" }}
              >
                {props.simulationData.Parcelas
                  ? props.simulationData.Parcelas.map((Parcela) => {
                      return (
                        <MenuItem value={Parcela}>
                          {Parcela.QuantidadeParcelas}x
                          {addMascaraReal(Parcela.Valor)}
                        </MenuItem>
                      );
                    })
                  : null}
              </Select>
            </p>
          </div>
          <div>
            <p>
              Valor original:{""}
              {addMascaraReal(
                props.simulationData.ValorInicial &&
                  props.simulationData.ValorInicial.toString()
              )}
            </p>
          </div>
          <div>
            <p>Quantidade de parcelas: {quantidadeDeParcelas}</p>
          </div>
          <div>
            <p>Valor da parcela: {ValorDaParcela}</p>
          </div>
          <div>
            <p>Valor total: {valorTotal}</p>
          </div>
          <div className="taxas">
            {taxaMensal !== null && taxaMensal !== "" && (
              <p>Taxa Mensal: {taxaMensal}% a.m.</p>
            )}
            {cet !== null && cet !== "" && <p>CET: {cet} a.a.</p>}
          </div>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => props.payMethod()}
          style={{ backgroundColor: "#699E42", color: "#fff" }}
        >
          Pagar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (store) => ({
  setPaymentCreditCardObject: store.cardDebitState.setPaymentCreditCardObject,
  paymentCreditCardObject: store.cardDebitState.paymentCreditCardObject,
  acquirerSelected: store.cardDebitState.acquirerSelected,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPaymentCreditCardObject,
    },
    dispatch
  );

export default withStyles({ withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(PaymentSimulation)
);
